import { Message } from '@arco-design/web-vue'
import type { AxiosResponse } from 'axios'
import { COOKIE_LOGIN_KEY, LOGIN_FAILED_RETRY_COUNT } from '@/constant/cache-key'
import { loadSessionStorage, removeSessionStorage, saveCookie, saveSessionStorage } from '@/utils/cache'
import { i18n } from '@/plugins/i18n'
import type { RbResponse } from '@/types/misc/http'
import store from '@/store'

export function throwErrorMessage(err: AxiosResponse<any, any>) {
  let message = i18n.global.t('common.request.defaultError')
  switch (err.status) {
    case 401:
      message = i18n.global.t('common.request.unauthorized')
      Message.warning(message)
      break
    case 403:
      message = i18n.global.t('common.request.forbidden')
      Message.error(message)
      break
    case 404:
      message = i18n.global.t('common.request.notFound')
      Message.error(message)
      break
    // case 405:
    //   message = '请求方法不允许!'
    //   Message.error(message)
    //   break
    // case 500:
    //   message = '服务器响应异常，请联系管理员'
    //   Message.error(message)
    //   break
    default:
      message = err.data.return_msg || err.data.msg
      Message.error(message)
  }
  return Promise.reject(message)
}

export function clearCookies() {
  return new Promise((resolve) => {
    const cookies = document.cookie.split(';')
    cookies.forEach((cookie) => {
      const [key] = cookie.split('=')
      document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
    })
    resolve(true)
  })
}

export async function handleTokenExpired(err: AxiosResponse<RbResponse<any>, any>) {
  const authStore = store.authStore
  // 未登录，且未模拟登录，则跳转到登录页面
  // if (
  //   err.data && err.data.content
  //   && err.data?.return_msg === '401 Unauthorized'
  //   && isLogin()
  //   && !getSimulated()
  // ) {
  //   const service = err.data.content.slice(err.data.content.indexOf('=') + 1)
  //   saveStorage('service', unescape(service))
  //   await authStore.renewalRoles() // 请求续期
  //   window.location.reload() // 续期后自动刷新
  //   return
  // }

  const loginFailedRetryCount = loadSessionStorage(LOGIN_FAILED_RETRY_COUNT, 0) || 0

  const message = i18n.global.t('common.request.unauthorized')
  Message.warning(message)
  authStore.logoutCallBack()
  const url = window.location.href
  // 保存当前页面的路径，登录后返回
  saveCookie(COOKIE_LOGIN_KEY, url, { path: '/' })

  // 本地开发时不进行跳转登录页
  if (document.domain === 'localhost' || document.domain.includes('192.168.')) {
    return
  }

  if (loginFailedRetryCount >= 3) {
    Message.warning(i18n.global.t('common.request.maxTry'))
    removeSessionStorage(LOGIN_FAILED_RETRY_COUNT)
    return
  }

  if (err.data?.content) {
    // 跳转到登录页面 并带上当前的语言配置
    window.location.href = `${err.data.content}&lang=${
      i18n.global.locale.value || 'en-US'
    }`
  }
  else {
    // 清空当前站点所有cookie
    saveSessionStorage(LOGIN_FAILED_RETRY_COUNT, loginFailedRetryCount + 1)
    await clearCookies()
    window.location.href = import.meta.env.VITE_APP_STP_API
  }
}
